// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__39maN","topBottomGutter":"Layout_topBottomGutter__2khZc"};